import { withRouter } from 'react-router-dom';
import './style.scss'
import Customer from '../Customer'
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import NoData from '../../components/NoData';

class CustomerList extends Component {

	render() {
		const { customers, handleClickCustomer, handleCancelServiceRequest, currentAgent, actions, dashboard, currentSession } = this.props
		return <div className="customer-list">
			<ul className='list'>
				{customers && customers.length ? customers.map(customer => <Customer
					key={customer._id}
					customer={customer}
					handleClickCustomer={handleClickCustomer}
					currentAgent={currentAgent}
					currentSession={currentSession}
					handleCancelServiceRequest={handleCancelServiceRequest}
					actions={actions}
					dashboard={dashboard} />
				) : <NoData />}
			</ul>
		</div>
	}
}

/**
 * Props that CustomerList component expects to be passed.
 */
CustomerList.propTypes = {
	// List title
	title: PropTypes.string.isRequired,
	// List icon
	icon: PropTypes.string,
	// Customers array
	customers: PropTypes.array
}

/**
 * Default props when CustomerList isn't passed any prop.
 */
CustomerList.defaultProps = {
	title: '',
	icon: '',
	customers: []
}

export default withRouter(CustomerList)
